import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, } from 'react-bootstrap';
import DetailedTransaction from './DetailedTransaction';
import DetailedTransactionV3 from './DetailedTransactionV3';
import DetailedTransactionLastFour from './DetailedTransactionLastFour';
import { tabKeys, } from '../../../modules/Constants';
import TransactionStrategy from './TransactionStrategy';

class DetailedTransactionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  getDetailedComponent(transaction, version) {
    switch (version) {
      case TransactionStrategy.V2:
        return <DetailedTransaction transaction={transaction} />;
      case TransactionStrategy.V3:
        return <DetailedTransactionV3 transaction={transaction} />;
      case TransactionStrategy.lastFour:
        return <DetailedTransactionLastFour transaction={transaction} />;
      default:
        return null;
    }
  }

  getBody(show) {
    const { transaction, version, } = this.props;
    if (!show) {
      return null;
    }
    return (
      <div>
        {this.getRefundButton()}
        <hr />
        {this.getDetailedComponent(transaction, version)}
      </div>
    );
  }

  getRefundButton() {
    const { transaction, } = this.props;
    const { isTabExistent, } = this.props;
    if (isTabExistent(tabKeys.REFUND_KEY)) {
      return (
        <Button variant="link" onClick={() => this.refundNavigationRequest(transaction)}>
          Refund
        </Button>
      );
    }
    return undefined;
  }

  handleClose() {
    this.setState({ show: false, });
  }

  refundNavigationRequest(transaction) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: tabKeys.REFUND_KEY,
      state: transaction,
    });
    this.handleClose();
  }

  handleShow() {
    this.setState({ show: true, });
  }

  render() {
    const { show, } = this.state;
    const { transaction, } = this.props;

    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>
        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>{transaction.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.getBody(show)}</Modal.Body>
        </Modal>
      </>
    );
  }
}

DetailedTransactionModal.propTypes = {
  transaction: PropTypes.instanceOf(Object).isRequired,
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
  isTabExistent: PropTypes.instanceOf(Function).isRequired,
  version: PropTypes.number.isRequired,
};

export default DetailedTransactionModal;
